export const selectUser = (user) => {
  console.log('You clicked on user: ', user.first)
  return {
    type: 'USER_SELECTED',
    payload: user
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js